import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

const useConvertAllocationApi = (invoiceId: number, useSinglePeriod: boolean) => {
  const call = useCallback(
    () => axiosInstance.post(api.convertAllocation(invoiceId), { useSinglePeriod }),
    [invoiceId, useSinglePeriod]
  );
  const { isLoading, execute } = useAsync(call, false, undefined);
  return {
    convertAllocation: execute,
    isLoading,
  };
};

export default useConvertAllocationApi;
